import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import UMDashboard from "../pages/university-manager/UMDashboard";
import UMUniversityInfo from "../pages/university-manager/UMUniversityInfo";
import UMCampuses from "../pages/university-manager/UMCampuses";
import UMFaculties from "../pages/university-manager/UMFaculties";
import UMDepartments from "../pages/university-manager/UMDepartments";
import UMAwaitingApproval from "../pages/university-manager/UMAwaitingApproval";
import UMAllEvents from "../pages/university-manager/UMAllEvents";
import UMClubs from "../pages/university-manager/UMClubs";
import UMUsers from "../pages/university-manager/UMUsers";
import UMFinanceTransfers from "../pages/university-manager/UMFinanceTransfers";
import UMLogRecords from "../pages/university-manager/UMLogRecords";
import uniAdminAuthService from "../services/university-admin/authService";

const UniversityManagerRoutes = () => {
  // Hard guard: this tree is the public, unauthenticated mock demo. A browser
  // that holds a live /uni-admin session must never be able to land here --
  // not via a stray Link, a bookmark, browser back/forward, or a typed URL --
  // so this check runs before any demo route can render, independent of how
  // navigation got here.
  if (uniAdminAuthService.isAuthenticated()) {
    return <Navigate to="/uni-admin/dashboard" replace />;
  }

  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<UMDashboard />} />
      <Route path="university-info" element={<UMUniversityInfo />} />
      <Route path="campuses" element={<UMCampuses />} />
      <Route path="faculties" element={<UMFaculties />} />
      <Route path="departments" element={<UMDepartments />} />
      <Route path="events/awaiting" element={<UMAwaitingApproval />} />
      <Route path="events/all" element={<UMAllEvents />} />
      <Route path="clubs" element={<UMClubs />} />
      <Route path="users" element={<UMUsers />} />
      <Route path="finance/transfers" element={<UMFinanceTransfers />} />
      <Route path="log-records" element={<UMLogRecords />} />
    </Routes>
  );
};

export default UniversityManagerRoutes;
